import React, { memo } from 'react';
import { useTheme } from 'emotion-theming';
export var ProductServiceReviews = /*#__PURE__*/memo(function (_ref) {
  var _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? '#003B5C' : _ref$stroke,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '88px' : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '125px' : _ref$width;

  var _useTheme = useTheme(),
      secondary = _useTheme.colors.secondary;

  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    width: width,
    height: height,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 79.8 71",
    style: {
      enableBackground: 'new 0 0 79.8 71'
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: secondary,
    d: "M73.9,6.8h-7.1c2.9,0,5.3,2.4,5.3,5.3v14.3c0,1.4-0.6,2.7-1.5,3.6c0,0.6,0.1,1.1,0.2,1.6h3.1 c2.9,0,5.3-2.4,5.3-5.3V12.1C79.2,9.1,76.8,6.8,73.9,6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: secondary,
    d: "M49.7,24.9c-1.1-1.9-2.6-3.1-4.4-4V21l0,0c-0.5-0.1-0.9-0.1-1.4-0.1h-8.7c4.3,0,7.9,3.5,7.9,7.9v21.3 c0,3-1.7,5.7-4.2,7c0.1,0.2,0.1,0.5,0,0.7c-0.3,3.2-0.3,6.3,0.2,9.5V58h4.8c4.3,0,7.9-3.6,7.9-7.9V31.6l0,0H52 C51.5,29.3,50.8,26.9,49.7,24.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: stroke,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M43.3,20.8H9c-4.3,0-7.9,3.6-7.9,7.9v21.3C1.1,54.4,4.7,58,9,58h15.5l13.9,10.8V58h4.8c4.3,0,7.9-3.6,7.9-7.9 V28.7C51.1,24.4,47.6,20.8,43.3,20.8z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: stroke,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: "15.3",
    y1: "33.6",
    x2: "35.8",
    y2: "33.6"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: stroke,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: "15.3",
    y1: "44",
    x2: "35.8",
    y2: "44"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: stroke,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M56,31.6h4.3l9.3,7.2v-7.2h3.2c2.9,0,5.3-2.4,5.3-5.3V12.1c0-2.9-2.4-5.3-5.3-5.3H50c-2.9,0-5.3,2.4-5.3,5.3 v4.1"
  }))));
});